import React from 'react'
import { omit } from 'lodash'
import { cn } from '@/lib/utils'
import spinner from '@/assets/images/spinner.svg'

interface ILoadingAnimate extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  iconClassName?: string
}

export default function LoadingAnimate(props: ILoadingAnimate) {
  const rest = omit(props, ['title', 'iconClassName'])
  return (
    <div
      {...rest}
      className={cn(
        'flex items-center justify-center text-center text-sm text-muted-foreground',
        rest.className
      )}
    >
      <img
        src={spinner}
        alt="Loading..."
        className={cn('w-24', props.iconClassName)}
      />
    </div>
  )
}
